// extracted by mini-css-extract-plugin
export default {"credits":"Credits_credits__57k6h","creative-commons":"Credits_creative-commons__sVfUV","social":"Credits_social__d0944","cc-icon":"Credits_cc-icon__zxHeX"};